var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCopyLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.806 12.034V2.3h7.965V.9H2.806c-.36 0-.669.14-.924.417A1.407 1.407 0 0 0 1.5 2.3v9.734h1.306zm9.956 4.166c.361 0 .674-.139.94-.416.265-.278.398-.606.398-.984V5.067c0-.378-.133-.7-.398-.967a1.283 1.283 0 0 0-.94-.4h-7.28c-.36 0-.674.134-.94.4a1.32 1.32 0 0 0-.398.967V14.8c0 .378.133.706.398.984.266.277.58.416.94.416h7.28zm-7.28-1.4h7.28V5.067h-7.28V14.8z",
    fill: "#18AB88"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopyLight);
export default __webpack_public_path__ + "static/media/ic-copy-light.144b596d3e18af0e91872029249169d4.svg";
export { ForwardRef as ReactComponent };